import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation login_user($username: String!, $password: String!) {
    login_user(input: { username: $username, password: $password }) {
      token
      status
      me {
        id
        first_name
        last_name
        mobile
        email
        organization {
          status
          id
          name
        }
        college {
          status
          id
          name
        }
      }
    }
  }
`;

export const CHECK_USER_EXISTENCE = gql`
  query check_user_existence($email: String!) {
    check_user_existence(email: $email) {
      status
    }
  }
`;

export const REGISTER = gql`
  mutation register_user_with_link($input: RegisterUserWithLinkInput!) {
    register_user_with_link(input: $input) {
      status
      errors,
      error
    }
  }
`;

export const CREATE_B2C_STUDENT = gql`
  mutation create_student($input: CreateStudentInput!) {
    create_student(input: $input) {
      status
      error
    }
  }
`;

export const CREATE_B2C_STUDENT_FROM_ADMIN = gql`
  mutation create_student_from_admin($input: CreateStudentFromAdminInput!) {
    create_student_from_admin(input: $input) {
      status
      error
    }
  }
`;

export const RESET_PASSWORD_REQUEST = gql`
  mutation reset_password_request($input: ResetPasswordRequestInput!) {
    reset_password_request(input: $input) {
      status
      error
    }
  }
`;

export const SET_PASSWORD = gql`
  mutation set_password($input: SetPasswordInput!) {
    set_password(input: $input) {
      status
      error
      token
      me {
        id
        first_name
        last_name
        mobile
        organization {
          status
          id
          name
        }
        college {
          status
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_LOCATIONS = gql`
  query all_locations {
    all_cities {
      id
      name
    }
  }
`;

export const GET_TEMPLATE = gql`
  query data_template {
    data_template {
      template
    }
  }
`;

export const BULK_UPLOAD = gql`
  mutation bulk_upload_candidates($input: BulkUploadCandidatesInput!) {
    bulk_upload_candidates(input: $input) {
      status
      error
      users {
        email
        error_message
      }
    }
  }
`;


// TODO add $file upload in input params
export const CREATE_USER = gql`
  mutation create_user($input: CreateUserInput!) {
    create_user(input: $input) {
      status
      error
      user {
        email
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation update_user($input: UpdateUserInput!) {
    update_user(input: $input) {
      status
      error
      user {
        email
      }
    }
  }
`;

export const DELETE_USERS = gql`
  mutation delete_users($ids: [ID!]!) {
    delete_users(input: {ids: $ids}) {
      status
      error
    }
  }
`;

export const DELIST_STUDENT = gql`
  mutation delist_students($ids: [ID!]!) {
    delist_students(input: {ids: $ids}) {
      status
      error
    }
  }
`;

export const GET_ALL_USERS = gql`
  query users(
    $filter: UserFilterInput
    $limit: Int
    $page: Int
    $is_student: Boolean
    $sort_by: String
  ) {
    users(
      filter: $filter
      limit: $limit
      page: $page
      is_student: $is_student
      sort_by: $sort_by
    ) {
      count
      users {
        id
        first_name
        last_name
        mobile
        email
        dob
        city {
          id
          name
        }
        gender
        qualification {
          id
          qualification {
            id
            name
          }
          course {
            id
            name
          }
          graduation_year
          specialization
          college_percentage
          college
        }
        work_preference {
          functional_area {
            id
            name
          }
          job_type_1
          job_type_2
          job_location
          minimum_expectation
          maximum_expectation
        }
        skills
        languages_known {
          language
          read
          write
          speak
        }
        work_experience {
          id
          company
          designation
          start_date
          end_date
        }
        status
      }
    }
  }
`;

export const EXPORT_STUDENTS = gql`
  query export_students(
    $filter: UserFilterInput
    $limit: Int
    $page: Int
    $is_student: Boolean
  ) {
    export_students(
      filter: $filter
      limit: $limit
      page: $page
      is_student: $is_student
    ) {
      report
    }
  }
`;

export const COLLEGE_INDUSTRY_CONNECT = gql`
  mutation create_campus_industry_connect($input: CreateCampusIndustryConnectInput!) {
    create_campus_industry_connect(input: $input) {
      status
      error
    }
  }
`;

export const GET_UPSKILLING_URL = gql`
  query get_upskilling_url {
    get_upskilling_url {
      status
      error
      loginurl
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query notifications {
    notifications {
      verb
      unread
      id
      timestamp
      description
      level
    }
  }
`;

export const MARK_AS_READ_NOTIFICATIONS = gql`
  mutation mark_as_read($input: MarkAsReadInput!) {
    mark_as_read(input: $input) {
      status
      error
    }
  }
`;

export const GET_RESUME_PDF = gql`
  query download_resume($id: ID!) {
    download_resume(id: $id) {
      file
    }
  }
`;

export const SEARCH_USER_JOBS = gql`
  query search_jobs(
    $filter: SearchJobFilterInput
    $limit: Int
    $page: Int
    $sort: String
  ) {
    search_jobs(filter: $filter, limit: $limit, page: $page, sort: $sort) {
      count
      jobs {
        id
        title
        job_type
        job_mode
        job_team_type
        description
        qualification {
          id
          name
        }
        category {
          id
          name
        }
        skills
        city {
          id
          name
        }
        location
        positions
        minimum_remuneration
        maximum_remuneration
        minimum_experience
        maximum_experience
        status
        is_saved
        job_status
        created_at
        updated_at
        organization
        salary_confidential
      }
    }
  }
`;

export const SEND_EMAIL = gql`
  query send_mail($input: EmailPayload!) {
    send_mail(input: $input) {
      status
      message
    }
  }
`;

export const GET_EMPLOYER_SUB_USERS = gql`
  query get_organization_employees(
    $filter: UserFilterInput
    $limit: Int
    $page: Int
    $sort_by: String
  ) {
    get_organization_employees(
      filter: $filter
      limit: $limit
      page: $page
      sort_by: $sort_by
    ) {
      count
      users {
        id
        first_name
        last_name
        mobile
        email
        designation
        roles
        status
        created_at
      }
    }
  }
`;

export const GET_ALL_ADMIN_USERS = gql`
  query get_admins(
    $filter: UserFilterInput
    $limit: Int
    $page: Int
    $sort_by: String
  ) {
    get_admins(filter: $filter, limit: $limit, page: $page, sort_by: $sort_by) {
      count
      users {
        id
        first_name
        last_name
        email
        mobile
        created_at
        designation
      }
    }
  }
`;

export const GET_SUBSCRIPTION_UTILIZATION_COUNT = gql`
  query get_subscription_utilization_count {
    get_subscription_utilization_count {
      status
      message
      response {
        utilized_jobs
        utilized_seats
        utilized_database
        organization_subscription {
          id
          name
          seats
          students
          jobs
        }
      }
    }
  }
`;

export const GET_USER_DETAILS = gql`
  query get_user_details($id: ID!) {
    user(id: $id) {
      id
      first_name
      last_name
      mobile
      designation
      landline_number
      email
      last_synced_all_moodle_courses_at
      is_contact_details_complete
    }
  }
`;
